export const DEFAULT_UNDEFINED_STRING = "unknown";
export const DEFAULT_UNDEFINED_NUMBER = 0;
